import { render, staticRenderFns } from "./expertAppointment.vue?vue&type=template&id=7ff8748a&scoped=true"
import script from "./expertAppointment.vue?vue&type=script&lang=js"
export * from "./expertAppointment.vue?vue&type=script&lang=js"
import style0 from "./expertAppointment.vue?vue&type=style&index=0&id=7ff8748a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff8748a",
  null
  
)

export default component.exports